import React from 'react';
import * as S from './styles';
import TextNoteItem from './components/TextNoteItem';
import WorkItem from './components/WorkItem';
import { ActionItem, Card } from '../../@types/domain';
import { ActionItemType } from '../../DomainEnums';

export type ActionItemProperties = {
  id: string;
  key: string;
  allowEdit?: boolean;
  allowRemove?: boolean;
  card: Card;
  item: ActionItem;
  index: number;
  handleClick: () => void | undefined | Promise<void>;
  children?: React.ReactNode;
};

function ActionItemView({
  id,
  children,
  item,
  card,
  handleClick,
  allowEdit,
  allowRemove,
  index,
}: ActionItemProperties) {
  const isTextNoteItem = item.type === ActionItemType.TEXT_NOTE;

  return (
    <S.Wrapper>
      {isTextNoteItem ? (
        <TextNoteItem
          card={card}
          item={item}
          allowEdit={allowEdit}
          allowRemove={allowRemove}
          index={index}
        />
      ) : (
        <WorkItem
          id={id}
          card={card}
          item={item}
          onClick={handleClick}
          allowEdit={allowEdit}
          allowRemove={allowRemove}
          index={index}
        />
      )}
      {children}
    </S.Wrapper>
  );
}

export default ActionItemView;
